// Entry point for the build script in your package.json

import "bootstrap";
import "@hotwired/turbo-rails";

import "trix";
import "@rails/actiontext";

import "./controllers";
import "./lib";
